declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../../models/api_request_model';
import { SpinnerService } from '../../../../../services/spinner.service';
import { AppData } from '../../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';



import { ActorService } from '../../../../../services/actor.service';

import * as alertFunctions from '../../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../../shared/services/toastr.service';
import { HcareService } from '../../../../../services/hcare.service';
import { JobApplyDetailsInfoByJobPostWithNurseController, JobApplyDetailsInfoByJobPostWithNurseRequest } from '../../../../../models/hcare/hcare.model';
import { ActorDocController, ActorDocRequest } from '../../../../../../../../src/app/ncs/models/actor/actor';
//import { ActorDocController } from '../../../../../../../../src/app/ncs/models/actor/actor';
//import { ActorDocRequest } from '../../../../../../../../src/app/ncs/models/actor/actor';

@Component({
  selector: 'documents',
  templateUrl: './documents.modal.html',
  styleUrls: ['./documents.modal.scss']
})

export class NgbDocumentModal implements OnInit {

  public isRequesting: boolean = false;
  public ApiResData: ApiResponseModel;
  @Input() ActorCode;
  @Input() ActorDocPageCode;
  @Input() DocTitle: string;
  @Input() DocCaptureDate: string;
  @Input() DocFriendlyName: string;
  //@Input() DocFriendlyName: string;

  //SelectedDocument: ActorDocController[];
  //CurrentActorDocRequest: ActorDocRequest;
  //@Input() CurrentActorDocRequest: ActorDocRequest;
  //@Input() CurrentActorDocControllerByCode: ActorDocController[];
  //CurrentActorDocController: ActorDocController[];
  //CurrentActorDocRequest: ActorDocRequest;

  //public ActorCode: number;

  public JobPostCode: number;
  public NurseActorCode: number;

  //public DocID: string;
  constructor(public activeModal: NgbActiveModal,
    private loaderService: SpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private actorservice: ActorService,
    private hcareservice: HcareService,
    private tosterservice: NGXToastrService) {

  }

  ngOnInit() {
    //this.GetActorDocController();
    //this.GetActorDocController();
  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }



  //GetActorDocController() {

  //  this.StartRefreshing();
  //  this.CurrentActorDocRequest = new ActorDocRequest();
  //  this.CurrentActorDocRequest.ActorCode = this.ActorCode;
  //  this.CurrentActorDocRequest.DocID = this.DocID;
  //  this.CurrentActorDocRequest.ConditionalOperator = 20;
  //  this.CurrentActorDocRequest.ActorDocPageCode = 0;
  //  this.CurrentActorDocRequest.DocType = "Clincial Record"
  //  this.CurrentActorDocRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;





  //  this.actorservice.GetActorDocController(this.CurrentActorDocRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {
  //        var result = this.ApiResData.Result;
  //        if (result.length > 0) {
  //          this.SelectedDocument = result[0];

  //        }

  //        this.stopRefreshing();

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParam(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.AlertParam(' Failed Due to Internal Error.... Please Contact Admin..');
  //        }
  //      }

  //    },


  //    (error) => {

  //      if (error == "401 - Unauthorized") {
  //        alertFunctions.AlertParam(error);
  //        this.stopRefreshing();



  //      }
  //      else {
  //        alertFunctions.AlertParam(error);
  //        this.stopRefreshing();
  //      }
  //    }


  //    );

  //}

  //GetActorDocController() {

  //  this.StartRefreshing();
  //  this.CurrentActorDocRequest = new ActorDocRequest();
  //  this.CurrentActorDocRequest.ActorCode = this.ActorCode;

  //  this.CurrentActorDocRequest.ConditionalOperator = 20;
  //  this.CurrentActorDocRequest.ActorDocPageCode = this.ActorDocPageCode;
  //  this.CurrentActorDocRequest.DocFriendlyName = this.DocFriendlyName;
  //  this.CurrentActorDocRequest.DocType = "Clincial Record"
  //  this.CurrentActorDocRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

  //  this.CurrentActorDocRequest.ActorDocPageCode = this.ActorDocPageCode;

  //  //alert(this.CurrentActorDocRequest.ActorDocPageCode);



  //  this.actorservice.GetActorDocController(this.CurrentActorDocRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        this.CurrentActorDocController = this.ApiResData.Result;
  //        //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController;

  //        //this.SelectedPatientEmergencyDetails = this.CurrentVitalLatestFormByFormattedCodeController[0];
  //        //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
  //        //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
  //        this.stopRefreshing();

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParam(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.AlertParam(' Failed Due to Internal Error.... Please Contact Admin..');
  //        }
  //      }

  //    },


  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParam(error);
  //          this.stopRefreshing();



  //        }
  //        else {
  //          alertFunctions.AlertParam(error);
  //          this.stopRefreshing();
  //        }
  //      }


  //    );

  //}

}
